import React, { Component } from 'react';
import _ from 'lodash';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { bindActionCreators } from "redux";
import { toast } from 'react-toastify';
import { connect } from "react-redux";
import APIUrls from '../../constants/ApiUrls';
import { APIManager } from "../../utils/api";
import { logout, updateTenant } from '../../actions/auth';
import { addEventNameToEndpoint } from '../../utils/common';
import { 
  STRIPE_STATUS, 
  isPartnerCustomer, 
  partnerBillingUrl, 
  getActiveSubscriptionFromCustomer, 
  getLastSubscriptionFromCustomer } from "../../utils/billing";
import "./Paywall.scss";

const PlanPeriod = {
  'YEAR': 'year',
  'MONTH': 'month'
};

const sortAmount = (p1, p2) => {
  if (p1.amount > p2.amount) {
    return 1;
  } else if (p1.amount === p2.amount) {
    return 0;
  } else {
    return -1
  }
}

// Stripe -- it's safe to include this key here
const stripe = Stripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY); //eslint-disable-line no-undef

class Paywall extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPlanInterval: PlanPeriod.MONTH, // the interval in the current UI
      currentPlanInterval: PlanPeriod.MONTH, // the customer's plan interval
      customerDetails: {},
      isLoading: false,
      yearPlans: [],
      monthPlans: []
    }

    this.axiosConfig = {};
    this.socket = null;
  }

  async componentDidMount() {
    // From willMount
    // const tokens = await this.props.Auth.currentSession();
    
    // this.axiosConfig = {
    //   headers: {
    //     'Authorization': `Bearer ${tokens.accessToken.jwtToken}`,
    //     'X-Identity': tokens.idToken.jwtToken,
    //     "Content-Type": "application/json",
    //   },
    //   crossdomain: true
    // };

    const { customerId, tenantId } = this.props.user;
    this.setState({ isLoading: true });

    // get customer details
    let customerDetails = {};
    try {
      customerDetails = await this.getCustomerDetails(customerId, tenantId);
    } catch (e) {
      this.setState({ isLoading: false });
      toast.error('Failed to get customer details: ' + e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    let allPlans = {};
    try {
      allPlans = await this.getPlans(customerDetails);
    } catch (error) {
      toast.error('Failed to get plans: ' + error.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    // let planType = _.get(response, 'subscriptions.data[0].plan.interval', '');
    // const planPeriod = planType === PlanPeriod.MONTH ? 0 : 1;

    // const planId = _.get(response, 'subscriptions.data[0].plan.id', '');
    // const yearPlans = plansResponse.filter(p => p.interval === 'year').sort(sortAmount);
    // const monthPlans = plansResponse.filter(p => p.interval === 'month').sort(sortAmount);

    // if (planPeriod === 0) {
    //   planType = monthPlans.findIndex(mp => mp.id === planId);
    // } else if (planPeriod === 1) {
    //   planType = yearPlans.findIndex(yp => yp.id === planId);
    // }

    this.setState({
      isLoading: false,
      customerDetails,
      currentPlanInterval: allPlans.currentPlanInterval,
      selectedPlanInterval: allPlans.currentPlanInterval || PlanPeriod.MONTH,
      yearPlans: allPlans.yearlyPlans,
      monthPlans: allPlans.monthlyPlans
    });
    //////
    if (this.props.user.accountStatus && this.props.user.accountStatus.status !== 'active' && this.props.user.accountStatus.status !== 'trialing') {

      const tokens = await this.refreshAuthorizedRequestConfig();
      this.socket = new WebSocket(`${APIUrls.socket}?authorization=${_.get(tokens, 'accessToken.jwtToken', '')}&identity=${_.get(tokens, 'idToken.jwtToken', '')}`);

      this.socket.onopen = () => {
        console.log('Connected to server correctly.');
      }
      
      this.socket.onmessage = message => {
        const data = JSON.parse(message.data);
        const { action } = data;

        switch (action) {
          case 'tenant-update': {
            const { updatedItems } = data;
            const tenantData = updatedItems[0];
            this.props.updateTenant(tenantData);

            if (tenantData.accountStatus.status === 'active' || tenantData.accountStatus.status === 'trialing') {
              this.props.history.push("/dashboard");
            }
            break;
          }
          case 'ping': {
            this.socket.send(JSON.stringify({ action: 'pong' }));
            break;
          }
          default:
            break;
        }
      };
    }
  }

  /**
   * Refresh tokens for requests
   * @returns (Object) jwt tokens
   */
  refreshAuthorizedRequestConfig = async () => {
    const tokens = await this.props.Auth.currentSession();
    
    this.axiosConfig = {
      headers: {
        'Authorization': `Bearer ${tokens.accessToken.jwtToken}`,
        'X-Identity': tokens.idToken.jwtToken,
        "Content-Type": "application/json",
      },
      crossdomain: true
    };

    return tokens;
  }

  /**
   * Get the customer details from Stripe including current subscription plan
   * @param {String} customerId 
   * @param {String} tenantId 
   */
  getCustomerDetails = async (customerId, tenantId) => {
    await this.refreshAuthorizedRequestConfig();
  
    const response = await APIManager.Instance.call("GET", APIUrls.getCustomerDetail(customerId, tenantId), this.axiosConfig);
    return response;
  }

  /**
   * Determine if the account is a trial account or delinquent or has no card -- should enable payment under both
   * of these conditions
   * @returns true if status is trialing or delinquent is true or there's no card
   */
  enableSubscribe = () => {
    const accountStatus = _.get(this.props.user, 'accountStatus.status', '');
    const delinquent = _.get(this.props.user, 'accountStatus.delinquent', '');
    const cardAttached = _.get(this.state.customerDetails, 'card', '');
    const enableSubscribe = (accountStatus === 'trialing' || delinquent || !cardAttached );
    return enableSubscribe;
  }

  /**
   * Get all the plans from Stripe
   * Break into monthly and yearly plans
   * Flag the current customer's plan
   * @returns (Object) {monthlyPlans, yearlyPlans, currentPlanInterval}
   */
  getPlans = async (customerDetails) => {
    await this.refreshAuthorizedRequestConfig();
    const response = await APIManager.Instance.call("GET", APIUrls.getPlansList, this.axiosConfig);
    
    // get the active sub or the last sub if no active subs
    let activeSubscription = await getActiveSubscriptionFromCustomer(customerDetails, true);

    
    // get the current plan interval
    let currentPlanInterval = _.get(activeSubscription, 'plan.interval', ''); //_.get(customerDetails, 'subscriptions.data[0].plan.interval', '');

    // find and flag the current plan description
    // there may not be a current plan if owner is on an expired trial
    // or has previously canceled
    const currentPlanId = _.get(activeSubscription, 'plan.id', ''); //_.get(customerDetails, 'subscriptions.data[0].plan.id', '');
    const currentPlan = response.find(p => p.id === currentPlanId);
    let availablePlans = [];
    if (currentPlan) {
      currentPlan.customerPlan = true;
      // filter out non-plan products
      // we only offer one product, so this selects for the family (eg Standard vs Partner) product
      availablePlans = response.filter(p => p.product === currentPlan.product);
    } else {
      // no current plan, so just use all standard plans
      availablePlans = response.filter(p => !p.nickname.includes('AppSumo'));
    }

    // break out plans by interval including the selected plan even if not active
    const yearlyPlans = availablePlans.filter(p => {
      return (p.interval === PlanPeriod.YEAR) && (p.active || p.customerPlan)
    }).sort(sortAmount);

    const monthlyPlans = availablePlans.filter(p => {
      return (p.interval === PlanPeriod.MONTH) && (p.active || p.customerPlan)
    }).sort(sortAmount);

    const allPlans = { monthlyPlans, yearlyPlans, currentPlanInterval}
    return allPlans;
  } 

  /**
   * Update the current subscription to the selected subscription
   * @param {String} planInterval
   * @param {String} planId
   */
  updateSubscription = async (planInterval, planId) => {
    const { customerId, tenantId } = this.props.user;
    const { monthPlans, yearPlans } = this.state;
    
    let plans = planInterval === PlanPeriod.MONTH ? monthPlans : yearPlans;
    let selectedPlan = plans.find( p => p.id === planId);
    
    
    const accountStatus = _.get(this.props.user, 'accountStatus.status', '');
    
    if (selectedPlan) {
      addEventNameToEndpoint(this.props.Analytics, 'user-paywall-subscribe');
      let response = null;

      // trialing account or inactive
      if (accountStatus !== 'active') {
        try {
          response = await APIManager.Instance.call("GET", APIUrls.getCheckoutSession(customerId, selectedPlan.id, tenantId, process.env.REACT_APP_API_CLIENT_BASE_URL), this.axiosConfig);
          stripe.redirectToCheckout({ sessionId: response.id });
        } catch (error) {
          toast.error('Failed to get checkout sessions: ' + error.message, {
            position: toast.POSITION.TOP_RIGHT
          });
          return;
        }
        // upgrade or downgrade
      } else {
        const subscriptionId = _.get(this.state.customerDetails, 'subscriptions.data[0].id', '');
        const oldPlanId = _.get(this.state.customerDetails, 'subscriptions.data[0].plan.id', '');

        try {
          response = await APIManager.Instance.call("POST", APIUrls.updateSubscription(customerId, subscriptionId), this.axiosConfig, { oldPlanId, newPlanId: selectedPlan.id })
          this.props.history.push('/billing');
        } catch (error) {
          toast.error('Failed to update subscription: ' + error.message, {
            position: toast.POSITION.TOP_RIGHT
          });
          return;
        }
      }
    } else {
      toast.error("We couldn't find your plan. Please contact our support team.", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }
  }

  logout = async () => {
    await this.props.Auth.signOut();
    this.props.logout();

    setTimeout(() => {
      this.props.history.push("/bye");
    });
  }


  ////////////////////////////////////////////
  // Render

  renderDisplayPriceMonthly = (plan) => {
    // monthly
    if (plan.interval === PlanPeriod.YEAR) {
      return plan.amount / 100 / 12;
    }
    // yearly
    return plan.amount / 100;
  }

  renderPlanCards = (selectedPlanInterval) => {
    const activeSubscription = getActiveSubscriptionFromCustomer(this.state.customerDetails);
    let userQuantity = _.get(activeSubscription, 'quantity', 1);

    let allPlans = [];
    if (selectedPlanInterval === PlanPeriod.MONTH) {
      allPlans = this.state.monthPlans;
    } else {
      allPlans = this.state.yearPlans;
    }

    const planCards = [];
    for (const plan of allPlans) {
      // build features
      const features = [];
      for (const feature of Object.keys(plan.metadata).sort()) {
        if (feature.startsWith("feature")) {
          features.push(<div className="feature-item" key={feature}>{plan.metadata[feature]}</div>)
        }
      }

      planCards.push(
        <div className="plan-card" key={plan.id}>
          {plan.customerPlan && (
            <div className="current-plan">Your current plan</div>
          )}
          <div className="plan-card-header">
            <div className="type">{plan.nickname}</div>
            <div className="description">
              {plan.metadata.description}
            </div>
            <div className="price">${this.renderDisplayPriceMonthly(plan)}</div>
            <div className="period">
              /user/month
              <br />
              {plan.interval === PlanPeriod.YEAR
                ? "billed annually (save 15%)"
                : "(billed monthly)"}
            </div>
          </div>
          {(!plan.customerPlan ||
            this.enableSubscribe()) && (
            <Button
              variant="success"
              disabled={ userQuantity > 1 && plan.amount === 0} // can't downgrade if too many users
              onClick={() => this.updateSubscription(plan.interval, plan.id)}
              data-cc-analytics-on="click"
              id="btnPaywallPlanTeam"
              data-cc-analytics-name="user-paywall-subscribe"
              data-cc-analytics-attrs={`userId:${
                this.props.username
              },planPeriod:${plan.interval},planName: ${plan.nickname}`}
            >
              Subscribe
            </Button>
          )}
          <div className="plan-details">
            <div className="feature">FEATURES</div>
            { features }
          </div>
        </div>
      );
    }
    return planCards;
  }
  
  render() {
    const { selectedPlanInterval, isLoading} = this.state;
    // const isAnnual = this.state.currentPlanInterval === PlanPeriod.YEAR ? true : false;
    const accountStatus = _.get(this.props.user, 'accountStatus.status', '');
    const isActiveAccount = accountStatus === 'active' || accountStatus === 'trialing';

    return (
      <div className="paywall-container">
        <div className="left-nav"></div>
        {isLoading ?
          <div className="loading-screen">
            <div className="ring">
              <span></span>
            </div>
            <div className="loading-description">Loading Billing Information</div>
          </div>
        :
          <div className="paywall-content">
            {!isActiveAccount && <div className="logout-button" onClick={this.logout}>Log out</div>}
            <div>
              <ButtonToolbar>
                <Button
                  variant={selectedPlanInterval === PlanPeriod.MONTH ? "primary" : "outline-primary"}
                  onClick={() => this.setState({ selectedPlanInterval: PlanPeriod.MONTH })}
                  size="sm"
                >
                  Monthly Plans
                </Button>
                &nbsp;
                <Button
                  variant={selectedPlanInterval === PlanPeriod.YEAR ? "primary" : "outline-primary"}
                  onClick={() => this.setState({ selectedPlanInterval: PlanPeriod.YEAR })}
                  size="sm"
                >
                  Annual Discount
                </Button>
              </ButtonToolbar>
            </div>
            <div className="plans-wrapper">
              { this.renderPlanCards(selectedPlanInterval) }
              <div className="plan-card">
                <div className="plan-card-header">
                  <div className="type">Enterprise</div>
                  <div className="description">Custom expansion plans for the enterprise.</div>
                  <div className="price">Contact Us</div>
                  <div className="period">Annual Plans</div>
                </div>
                <Button variant="success"
                  data-cc-analytics-on='click'
                  id="btnPaywallEnterpriseContact"
                  data-cc-analytics-name='user-paywall-contact'
                  onClick={() => {
                      addEventNameToEndpoint(this.props.Analytics, 'user-paywall-contact');
                      window.open(`${process.env.REACT_APP_CONTACT_US_ENTERPRISE}`, "_blank")
                    }
                  }
                >
                  Schedule Call
                </Button>
                <div className="plan-details">
                  <div className="feature">FEATURES</div>
                  <div className="feature-item">Custom User Quantity</div>
                  <div className="feature-item">Custom Storage Amount</div>
                  <div className="feature-item">Custom # Assets</div>
                  <div className="feature-item">Everything in TEAM plus:</div>
                  <div className="feature-item">Single Sign-on</div>
                  <div className="feature-item">Fine-grained Access Control</div>
                  <div className="feature-item">Advanced Analytics</div>
                  <div className="feature-item">Integrations (Hubspot, Marketo, Salesforce)</div>
                </div>
              </div>
            </div>
              <br/>
              <br/>
            <div className="learn-more">
              <p>Looking for more information? <a href="https://www.contentcamel.io/tour/">View all the details here in our tour {">"}</a></p>
              <p>Have a question? <a href="mailto:support@contentcamel.io?subject=Quick question">Email us <span role="img" aria-label="happy">✉️</span></a> or <a href={process.env.REACT_APP_CONTACT_US_30}>schedule time with us <span role="img" aria-label="camel">🐪</span>.</a> </p>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.tenant,
  username: state.auth.cognitoUser.username,
  Auth: state.auth.Auth,
  Analytics: state.auth.Analytics
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    logout,
    updateTenant
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Paywall);
